<template>
  <div class="d-inline-flex">
    <small class="m-1 mr-3">from</small>
    <b-input-group class="input-date-container">
      <b-form-input
        v-model="fromDate"
        type="text"
        autocomplete="off"
        size="sm"
        disabled
      ></b-form-input>
      <b-input-group-append>
        <b-form-datepicker
          v-model="fromDate"
          :max="toDate"
          button-only
          size="sm"
          right
        ></b-form-datepicker>
      </b-input-group-append>
    </b-input-group>
    <small class="m-1 mx-3">to</small>
    <b-input-group class="input-date-container">
      <b-form-input
        v-model="toDate"
        type="text"
        autocomplete="off"
        size="sm"
        disabled
      ></b-form-input>
      <b-input-group-append>
        <b-form-datepicker
          v-model="toDate"
          :min="fromDate"
          button-only
          size="sm"
          right
        ></b-form-datepicker>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'FilterDate',
  props: {
    filter: {
      type: Object,
      required: true,
    },
    selectedCubeId: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    if (this.filter.options.length) {
      this.getDateFromSavedData();
    }
  },
  watch: {
    filter() {
      if (this.filter.options.length) {
        this.getDateFromSavedData();
      }
    },
    fromDate() {
      this.changed();
    },
    toDate() {
      this.changed();
    },
  },
  data() {
    return {
      isLoading: false,
      selectedValues: [],
      toDate: dayjs().format('YYYY-MM-DD'),
      fromDate: dayjs().format('YYYY-MM-DD'),
    };
  },
  computed: {
    formattedDateFilter() {
      return (
        this.formatDate(this.fromDate) + ' : ' + this.formatDate(this.toDate)
      );
    },
  },
  methods: {
    formatDate(date) {
      let formattedDate = this.filter.level.levelId + '.&[' + date;
      if (this.filter.level.levelDbType === 'DATE1') {
        formattedDate += 'T00:00:00';
      }
      formattedDate += ']';
      return formattedDate;
    },
    getDateFromSavedData() {
      const dates = this.filter.options[0].value.split(' : ');
      if(dates) {
        let fromDate = dates[0].split('].&[')[1];
        fromDate = fromDate.substring(0, fromDate.length - 10);
        let toDate = dates[1].split('].&[')[1];
        toDate = toDate.substring(0, toDate.length - 10);
        this.fromDate = fromDate;
        this.toDate = toDate;
      }
      
    },
    changed() {
      this.$emit('input', [
        { group: '-', text: '-', value: this.formattedDateFilter },
      ]);
    },
  },
};
</script>

<style scoped></style>